<template>
  <div>
    <div class="share-head" v-if="shareModal">
      <van-image
        width="38"
        height="38"
        :src="require('../../assests/imgs/logo.png')"
      />
      <div class="share-text">
        <span>小豆苗</span>
        <span>管理宝宝打疫苗的APP</span>
      </div>
      <span :class="{'more-btn':!isWx}" class="more-wrapper">
        <span class="more">{{ headerText }} </span>
        <span class="share-template" id="more"></span>
      </span>
      <span class="share-close" @click="downLoadClose"></span>
    </div>
    <span class="share-btn" v-if='footerText'>
      {{ footerText }}
      <span class="share-template" id="share-btn"></span>
    </span>
  </div>
</template>

<script>
import {Image as VanImage} from 'vant';
export default {
  name: 'NewShare',
  components: {
    VanImage
  },
  props: {
    headerText: {
      type: String,
      default: '查看更多'
    },
    footerText: {
      type: String,
      default: '我也要测评'
    }
  },
  data() {
    return {
      shareModal: true,
      isWx: /micromessenger/.test(navigator.userAgent.toLowerCase())
    };
  },
  methods: {
    downLoadClose() {
      this.shareModal = false;
    }
  },
};
</script>

<style lang="less" scoped>
  .share-head {
    display: flex;
    padding: 0 30px;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    height: 120px;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    box-sizing: border-box;
    z-index: 999;

    .share-text {
      display: flex;
      flex-direction: column;
      flex: 1;
      margin-left: 20px;
      color: #fff;
      font-size: 28px;
      line-height: 1;

      span:first-child {
        font-size: 32px;
        font-weight: bold;
      }

      span + span {
        padding-top: 8px;
      }
    }
    .more-wrapper {
      position: relative;
      display: flex;
      align-items: center;
    }
    .more {
      display: inline-block;
      width: 160px;
      height: 66px;
      line-height: 66px;
      border-radius: 100px;
      text-align: center;
      background-image: linear-gradient(90deg, #27B475, #65CE3B);
      color: #fff;
      font-size: 28px;
    }

    .more-btn {
      width: 158px;
      height: 52px;
      line-height: 52px;
      font-size: 28px;
      color: #fff;
      text-align: center;
      background-color: #7bd557;
      border-radius: 26px;
    }
  }

  .share-close {
    width: 60px;
    height: 60px;
    background: url("./imgs/icon-quxiao.png") no-repeat center;
    background-size: 34px 34px;
  }

  .share-btn {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 80px;
    z-index: 999;
    box-sizing: border-box;
    font-size: 28px;
    color: #FFFFFF;
    font-weight: 500;
    text-align: center;
    background-image: linear-gradient(90deg, #27B475, #65CE3B);
    border-radius: 100px;
    padding: 24px 36px;
  }
</style>



// WEBPACK FOOTER //
// src/components/NewShare/index.vue